import { createGlobalStyle } from 'styled-components';
import color from '../../configs/color';

const CustomStyle = createGlobalStyle`
  .ant-tooltip-inner {
    background-color: ${color.grey5};
    color: ${color.black1};
    padding: 12px 16px;
  }
  .ant-tooltip-arrow {
    .ant-tooltip-arrow-content {
      background-color: ${color.grey5};
      height: 8px;
      width: 8px;
    }
  }
`;

export default CustomStyle;
